export enum Region {
    Dordogne = 'La Dordogne',
    Bretagne = 'La Bretagne',
    Vendee = 'La Vendée',
    IleDeRe = 'Ile de Ré',
    LacDAnnecy = 'Le Lac d\'Annecy',
    ChateauxDeLaLoire = 'Les châteaux de la Loire',
    HauteMarne = 'La Haute-Marne',
    IleDeFrance = 'Ile de France',
    Lacanau = 'Lacanau',
    Ardeche = 'Ardèche'
};